import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VuePaginate from "vue-paginate";
import Vuelidate from 'vuelidate';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueScrollTo from 'vue-scrollto'
import axios from 'axios';
import commonFunctions from '@/common/commonFunctions';
import jQuery from 'jquery'
global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')
Vue.use(VueSweetalert2);
Vue.use(VueScrollTo);

Vue.use(VuePaginate);

Vue.use(Vuelidate)

Vue.use(commonFunctions);
Vue.config.productionTip = false
let vm = Vue.prototype;
var baseURL = "/PAYPAY";
// var baseURL = "/sellers_web_paypay";
axios.defaults.baseURL = baseURL;

axios.interceptors.response.use( 
  res=> {
    // 成功時の処理
    return res;
  }, 
  async err =>{
    var errMsg = err.response.data;
    if(!errMsg.title) errMsg.title = "処理";
    // 失敗時の処理
    switch(err.response.status){
      
      case 401:
      // HTTPステータスに応じて処理
      await vm.$functions.swNgAlert(vm, 'error', `${errMsg.title}に失敗しました`, errMsg.errMsg)
      .then(res=>{
        window.location.href = './';
      })
      break;
      case 403:

        case 500:
          await vm.$functions.swNgAlert(vm, 'error', `${errMsg.title}に失敗しました`, errMsg.errMsg)
          break;
      default:
        await vm.$functions.swNgAlert(vm, 'error', `エラーがありました`, '')
        
        break;
      // 例外処理  
    }
    throw '';
});


new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
